<template>
	<div class="task_page-new" id="task_answer">
    	<!--<span class="task_answer_span"></span>-->
		<div class="task_main" ref="middle_page">
			<div class="taskPage">  
				<div class="primarylists list-mobile">
					<div class="titles clear">
						<img src="../../../static/images/icon-st.jpg" alt="" />
						<span class="title l">{{outlineInfo.courseName}}</span>
						<p>
							<span class="title l">{{homeWorkName}}</span>
						</p>
					</div>
				</div>
				<div class="div-btn-icon">
					<button class="btn-tast btn-next-1" @click="goto_lesson">
						<img src="../../../static/images/icon-back-1.png" alt="" />
						<span>{{$t('common.returnButton')}}</span>
					</button>
					<template v-if="questions!=null&&currentQuestionInfo.questionNum==1">
						<button
							style="cursor: no-drop;"
							class="btn-tast"
						>
							<img src="../../../static/images/back-den.png" alt="" />
							<span style="color: black">{{$t('task_result.prev')}}</span>
						</button>
					</template>
					<template v-else>
						<button
							class="btn-tast btn-z-index"
							@click="changeQuestion(currentQuestionInfo.questionNum -1)"
						>
							<img src="../../../static/images/icon-back.png" alt="" />
							<span>{{$t('task_result.prev')}}</span>
						</button>
					</template>
					<template v-if="questions!=null&&currentQuestionInfo.questionNum==this.questions.length">
						<button
							style="cursor: no-drop;"
							class="btn-tast xoay"
						>
							<img src="../../../static/images/back-den.png" alt="" />
							<span style="color: black">{{$t('task_result.next')}}</span>
						</button>
					</template>
					<template v-else>
						<button
							class="btn-tast xoay"
							@click="changeQuestion(currentQuestionInfo.questionNum + 1)"
						>
							<img src="../../../static/images/icon-back.png" alt="" />
							<span>{{$t('task_result.next')}}</span>
						</button>
					</template>
				</div>
				<div class="taskPage_task taskPage_task_edit"> 
					<div class="taskContent_main">
						<div class="task-flex">
							<div class="task_content">
								<div class="fix-img-h" v-html="currentQuestionInfo.questionContent"></div>
								<audio v-if="currentQuestionInfo.audioName != undefined && currentQuestionInfo.audioName != null && currentQuestionInfo.audioName != '' && 'mp3' == currentQuestionInfo.audioName.substring(currentQuestionInfo.audioName.lastIndexOf('.')+1)" 
										controls="controls" 
										:src="currentQuestionInfo.audioPath" 
										controlsList="nodownload" 
										oncontextmenu=" return false" 
										class="audio"
								></audio>
								<video v-if="currentQuestionInfo.audioName != undefined && currentQuestionInfo.audioName != null && currentQuestionInfo.audioName != '' && 'mp4' == currentQuestionInfo.audioName.substring(currentQuestionInfo.audioName.lastIndexOf('.')+1)" 
									:src="currentQuestionInfo.audioPath" 
									controls="controls"
									controlsList="nodownload"
									class="video"
								></video>
							</div>
							<div class="tast-right" v-if="currentQuestionInfo.questionTypeId=='1'">
								<div class="task_answer_radio">
								<p v-if="currentQuestionInfo.optionA">
									<input v-model="radioValue" id="radio_a" type="radio" name="radio" value="A" disabled="disabled"/>
									<label for="radio_a">
									<span class="left_span"></span>
									<span class="right_span" v-html="currentQuestionInfo.optionA"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionB">
									<input v-model="radioValue" id="radio_b" type="radio" name="radio" value="B" disabled="disabled"/>
									<label for="radio_b">
									<span class="left_span"></span>
									<span class="right_span" v-html="currentQuestionInfo.optionB"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionC">
									<input v-model="radioValue" id="radio_c" type="radio" name="radio" value="C" disabled="disabled"/>
									<label for="radio_c">
									<span class="left_span"></span>
									<span class="right_span" v-html="currentQuestionInfo.optionC"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionD">
									<input v-model="radioValue" id="radio_d" type="radio" name="radio" value="D" disabled="disabled"/>
									<label for="radio_d">
									<span class="left_span"></span>
									<span class="right_span" v-html="currentQuestionInfo.optionD"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionE">
									<input v-model="radioValue" id="radio_e" type="radio" name="radio" value="E" disabled="disabled"/>E.&nbsp;
									<label for="radio_e">
									<span v-html="currentQuestionInfo.optionE"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionF">
									<input v-model="radioValue" id="radio_f" type="radio" name="radio" value="F" disabled="disabled"/>F.&nbsp;
									<label for="radio_f">
									<span v-html="currentQuestionInfo.optionF"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionG">
									<input v-model="radioValue" id="radio_g" type="radio" name="radio" value="G" disabled="disabled"/>G.&nbsp;
									<label for="radio_g">
									<span v-html="currentQuestionInfo.optionG"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionH">
									<input v-model="radioValue" id="radio_h" type="radio" name="radio" value="H" disabled="disabled"/>H.&nbsp;
									<label for="radio_h">
									<span v-html="currentQuestionInfo.optionH"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionI">
									<input v-model="radioValue" id="radio_i" type="radio" name="radio" value="I" disabled="disabled"/>I.&nbsp;
									<label for="radio_i">
									<span v-html="currentQuestionInfo.optionI"></span>
									</label>
								</p>
								<p v-if="currentQuestionInfo.optionJ">
									<input v-model="radioValue" id="radio_j" type="radio" name="radio" value="J" disabled="disabled"/>J.&nbsp;
									<label for="radio_j">
									<span v-html="currentQuestionInfo.optionJ"></span>
									</label>
								</p>
								</div>
							</div>
							<div class="tast-right" v-if="currentQuestionInfo.questionTypeId=='2'">
								<div class="task_answer_radio task_answer_checkbox">
								<p v-if="currentQuestionInfo.optionA">
									<input class="ip-check" v-model="checkedValue" id="checkbox_a" type="checkbox" value="A" disabled="disabled"/>
									<label for="checkbox_a" v-html="currentQuestionInfo.optionA"></label>
								</p> 
								<p v-if="currentQuestionInfo.optionB">
									<input class="ip-check" v-model="checkedValue" id="checkbox_b" type="checkbox" value="B" disabled="disabled"/>
									<label for="checkbox_b" v-html="currentQuestionInfo.optionB"></label>
								</p> 
								<p v-if="currentQuestionInfo.optionC">
									<input class="ip-check" v-model="checkedValue" id="checkbox_c" type="checkbox" value="C" disabled="disabled"/>
									<label for="checkbox_c" v-html="currentQuestionInfo.optionC"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionD">
									<input class="ip-check" v-model="checkedValue" id="checkbox_d" type="checkbox" value="D" disabled="disabled"/>
									<label for="checkbox_d" v-html="currentQuestionInfo.optionD"></label>
								</p>     
								<p v-if="currentQuestionInfo.optionE">
									<input class="ip-check" v-model="checkedValue" id="checkbox_e" type="checkbox" value="E" disabled="disabled"/>
									<label for="checkbox_e" v-html="currentQuestionInfo.optionE"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionF">
									<input class="ip-check" v-model="checkedValue" id="checkbox_f" type="checkbox" value="F" disabled="disabled"/>
									<label for="checkbox_f" v-html="currentQuestionInfo.optionF"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionG">
									<input class="ip-check" v-model="checkedValue" id="checkbox_g" type="checkbox" value="G" disabled="disabled"/>
									<label for="checkbox_g" v-html="currentQuestionInfo.optionG"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionH">
									<input class="ip-check" v-model="checkedValue" id="checkbox_h" type="checkbox" value="H" disabled="disabled"/>
									<label for="checkbox_h" v-html="currentQuestionInfo.optionH"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionI">
									<input class="ip-check" v-model="checkedValue" id="checkbox_i" type="checkbox" value="I" disabled="disabled"/>
									<label for="checkbox_i" v-html="currentQuestionInfo.optionI"></label>
								</p>  
								<p v-if="currentQuestionInfo.optionJ">
									<input class="ip-check" v-model="checkedValue" id="checkbox_j" type="checkbox" value="J" disabled="disabled"/>
									<label for="checkbox_j" v-html="currentQuestionInfo.optionJ"></label>
								</p>
								</div>
							</div>
							<div class="tast-right tast-chat" v-if="currentQuestionInfo.questionTypeId=='3' || currentQuestionInfo.questionTypeId=='4'">
								<div class="task_answer_text">
									<textarea name="" :placeholder="$t('errorBook.answerInput')" v-model="textAnswer" disabled="disabled"></textarea>
								</div>
							</div>
							<div class="task_result">
								<ul>
									<li class="task_result_content" v-if="currentQuestionInfo.isRight =='0'">
										<img src="../../../static/images/all-error.png" />
										<span class="task_result_content_wrong">{{$t('task_result.wrong')}}</span>
									</li>
									<li class="task_result_content" v-if="currentQuestionInfo.isRight =='1'">
										<img src="../../../static/images/correct.png" />
										<span class="task_result_content_rigth">{{$t('task_result.reght')}}</span>
									</li>
								</ul>
								<div class="task_result_answer">
									<p class="task_result_answer_a">{{$t('task_result.answer')}}：</p>
									<p class="task_result_answer_b" v-html="currentQuestionInfo.questionAnswer"></p>
								</div>
								<br>
								<div class="task_result_analysis" v-show="currentQuestionInfo.questionAnalysis">
									<p class="task_result_analysis_a">{{$t('task_result.analysis')}}： </p>
									<p v-html="currentQuestionInfo.errorReason"></p>
								</div>
								<div class="task_result_analysis_answer" v-show="currentQuestionInfo.questionAnalysis">
									<p v-html="currentQuestionInfo.questionAnalysis"></p>
								</div>
							</div>
						</div>
						<div class="taskContent_page">
							<ul>
								<li v-for="(item,index) in questions" 
									@click="current_change(index+1)" 
									:key="index" 
									:class="{taskContent_page_active:index==currentQuestionInfo.questionNum-1&&pageActiveBegin==true, task_right:item.isRight==1, task_wrong:item.isRight==0, taskContent_page_active_border:index==currentQuestionInfo.questionNum-1}"
								>
									<p>{{index+1}}</p>
									<!-- <label v-if="item.isRight == '1'" class="task_right"></label>
									<label v-else class="task_wrong"></label> -->
								</li>
							</ul>
							<!-- <div class="taskContent_page">
								<el-pagination
									class="task_el_pagination"
									:current-page="currentQuestionInfo.questionNum"
									background
									layout="pager"
									:pageSize="1"
									:total="this.totalNum"
									hide-on-single-page="true"
									@current-change="current_change"
								>
								</el-pagination>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<loading :showLoading="showLoadingFlg" />
  	</div>
</template>

<script>
	// not use
	// import hljs from 'highlight.js'
	// import 'highlight.js/styles/darkula.css'
	// not use
	import 'quill/dist/quill.snow.css'
	import loading from "@/components/loading/loading";
	//国际化引入
 	import Vue from 'vue'
	import {lang} from '../../assets/languages/getLanguageType.js';
  	Vue.prototype.$lang = lang;
	export default {
		name: 'task_result_manage',
		components: {
			loading
		},
		data() {
			return {
				pageActiveBegin: false,
				showLoadingFlg: false,
				userId: null, //用户id
				currentQuestionInfo: {},
				homeWorkName: '',
				questions: [],
				outlineInfo: {},
				type: 'radio', //1.radio:单选,2.checkbox:多选,3.text:填空,4.tast_edit:编程界面
				textAnswer: null, //填空题答案
				totalNum: null, // 总题数
				checkedValue: [], //复选框选中
				radioValue: null, //单选选中
				spendTime: 0, //作业用时
				content: null,
		// 		editorOption: {
		// 			modules: {
		// 				syntax: {
		// 					highlight: text => hljs.highlightAuto(text).value
		// 				},
		// 				toolbar: [
		// 					['code-block'],
		// 				]
		// 			},
		// 			theme: 'snow',
        // //   placeholder: window.vm.$i18n.t('js.placeholder'),
		// 		}
			}
		},
		mounted() {
			const h = document.body.clientHeight - 299
			this.$autoLogin().then(() => {
				this.showLoadingFlg = true;
				const that = this;
				that.userId = window.sessionStorage.getItem("id");
				that.outlineInfo = eval('(' + that.$route.query.outlineInfo + ')');
				that.$api.post("/courseStudy/getLastHomeworkInfo", {
							"courseOutlineId": that.outlineInfo.courseOutlineId,
							"studentId": this.$route.query.studentId,
							"languageType": that.$lang()
				}).then(
					(response) => {
            			that.questions = response.data;
						that.questions.forEach(function(obj) {
							obj.questionNum = parseInt(obj.questionNum);
							if (obj.questionTypeId == '2') {
								obj.commitAnswer = obj.commitAnswer == null || obj.commitAnswer == '' ? [] : obj.commitAnswer.split(",");
							}
							if(obj.errorReason != null && obj.errorReason != undefined) {
								obj.errorReason = obj.errorReason.replaceAll("\r\n","<br>").replaceAll("\n","<br>");
							}
						})
            			that.currentQuestionInfo = that.questions[0];
            			that.totalNum = response.data.length;
						if (that.currentQuestionInfo.questionTypeId == '1') {
              				that.radioValue = that.currentQuestionInfo.commitAnswer;
						} else if (that.currentQuestionInfo.questionTypeId == '2') {

							if (that.currentQuestionInfo.commitAnswer == null) {
								that.checkedValue = "";
							} else {
								that.checkedValue = that.currentQuestionInfo.commitAnswer.toString().split(",");
							}
						} else {
							that.textAnswer = that.currentQuestionInfo.commitAnswer;
						}
						this.showLoadingFlg = false;
					}
				)
			}, () => {
				this.$router.push({
					path: "/home"
				})
			})
		},
		methods: {
			current_change: function(val) {
				if(!this.pageActiveBegin) {
					if(val > 1) {
						this.pageActiveBegin = true;
					}
				}
				//alert(`当前页: ${val}`);
				this.changeQuestion(val);
			},

			changeQuestion: function(questionNum) {
				if(questionNum > 1) {
					this.pageActiveBegin = true;
				}
				//清除页面答案
				this.textAnswer = null;
				this.radioValue = null;
				this.checkedValue = [];
				//切换问题
				this.currentQuestionInfo = this.questions[questionNum - 1];
				//答案赋值
				if (this.currentQuestionInfo.questionTypeId == '1') {
					this.radioValue = this.currentQuestionInfo.commitAnswer;
				} else if (this.currentQuestionInfo.questionTypeId == '2') {
					this.currentQuestionInfo.commitAnswer == null ? this.checkedValue = "" : this.checkedValue = this.currentQuestionInfo
						.commitAnswer.toString().split(",");
				} else {
					this.textAnswer = this.currentQuestionInfo.commitAnswer;
				}
			},

			goto_lesson: function() {
				if (this.$route.query.pageManage=="lesson") {
					this.$router.push({
						path: "/home/manage/lessons"
					})
				} else {
					let outlineInfo = {
						"courseId": this.outlineInfo.courseId,
						"courseName": this.outlineInfo.courseName,
						"chapterId": this.outlineInfo.topId
					};
					this.$router.push({
						path: "/home/manage/students",
						query: {
							studentId: this.$route.query.studentId,
							courseId: this.outlineInfo.courseId
						}
					})
				}
				
			}
		}
	}
</script>

<style scoped="scoped">
.task_page {
  width: 100%;
  min-width: 480px;
  background-color: rgb(100, 101, 112);
  background: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}

.task_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.taskPage {
  /*min-width: 1200px;*/
  width: 80%;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 50px;
  position: relative;
}

.task_answer_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.taskPage_top {
  margin-top: 60px;
}

.taskPage_top p {
  width: calc(60% + 80px);
  /* height: 30px; */
  line-height: 30px;
  margin: 0 auto;
  /* color: #e8e6e6; */
  font-size: 30px;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
}

.taskPage_top p:last-child {
  font-size: 20px;
}

.taskPage_task_b {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0px 0px 20px 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
  min-height: 50px;
  position: relative;
}

.taskPage_task {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  margin-top: 40px;
  /*padding: 0 20px;*/
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px 20px 0px 0px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

.taskPage_task .task_top {
  height: 40px;
  line-height: 40px;
}

.previous_task {
  position: relative;
  float: left;
  cursor: pointer;
}

.next_task {
  position: relative;
  float: right;
  margin-top: -40px;
  cursor: pointer;
}

.taskContent_page {
	width: 80%;
	height: 40px;
	position: relative;
	margin: 0 auto;
}

/* 	.taskContent_page::-webkit-scrollbar {
		display: none;
	}
*/
/* 设置滚动条的样式 */
.taskContent_page ::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 100%;
	height: 10px;
	border-radius: 20px;
}

.taskContent_page ::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	cursor: pointer;
	border-radius: 20px;
	background-color: #646469;
}

.taskContent_page ::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	border-radius: 20px;
	background-color: #cfcbcb;
}

.taskContent_page ul {
	/* max-width: 480px; */
	list-style: none;
	overflow: auto;
	white-space: nowrap;
	text-align: center;
}

.taskContent_page ul li {
	width: 36px;
	height: 36px;
	background-color: #1f1f1e;
	border-radius: 10px;
	margin-right: 5px;
	text-align: center;
	display: inline-block;
	margin-bottom: 6px;
	position: relative;
	cursor: pointer;
}

.taskContent_page ul li p {
	width: 36px;
	height: 24px;
	line-height: 35px;
	font-family: SourceHanSansCN-Normal;
	font-size: 15px;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #181616;
	outline: none;
	user-select: none;
}

.taskContent_page ul li:last-child {
	margin-right: 0;
}

.taskContent_page .taskContent_page_active p {
	color: #fff;
}
.taskContent_page .taskContent_page_active{
	background: rgba(0, 0, 0, 0.6)!important;
}
.taskContent_page_active_border {
	border: 1px rgba(0, 0, 0, 0.6) solid !important;
}
.taskContent_main {
  margin-top: 20px;
  padding: 0 100px;
  font-size: 14px;
  /* color: #e8e6e6; */
  text-align: left;
  /*height: 270px;*/
  word-wrap: break-word;
  /* word-break: break-all; */
}

.taskContent_main .task_content {
  line-height: 20px;
  font-size: 14px;
  /* color: #e8e6e6; */
  /* text-align: left; */
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.taskContent_main .task_content p {
  width: 100%;
}

.taskContent_main .answer_note {
  margin-bottom: 10px;
  color: #ff5252;
  font-size: 12px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.task_answer_radio {
  /*min-width: 450px;*/
  /*width: cacl(60% - 50px);*/
  margin-top: 20px;
  /*margin-left: 20px;*/
}

.task_answer_radio p {
  width: calc(100% - 40px);
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  /* text-align: left; */
  /*margin-left: 20px;*/
  margin-top: 15px;
  /* display: inline-flex; */
  display: -webkit-box;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.task_answer_radio p label {
  display: -webkit-box;
}

.task_answer_radio p span {
  cursor: pointer;
}

.task_answer_radio input {
  height: 13px;
  margin-right: 10px;
  margin-top: 5px;
}

.task_answer_text {
  margin-top: 20px;
  width: calc(100% - 40px);
  padding: 2px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #585858;
  border-radius: 20px;
}
.task_answer_text:focus {
  border: 1px #ff5252 solid !important;
}

.task_answer_text textarea {
  margin-top: 2px;
  margin-right: 1px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 160px;
  line-height: 20px;
  background-color: #fff;
  border-radius: 20px;
  /* background:url("../../../static/images/manual_zh_10.png") no-repeat; */
  font-size: 14px;
  color: #0f0f0f;
  text-align: left;
  border: 0;
  outline: none;
  padding-left: 8px;
  padding-right: 8px;
  /* resize: none; */
}
.task_answer_text textarea:focus {
  border: 0 !important;
  background: #585858;
  color: #e8e6e6;
}

.task_answer_text textarea::-webkit-input-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #e8e6e6;
}

.task_answer_text textarea:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #e8e6e6;
}

.task_answer_text textarea:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #e8e6e6;
}
.submitButton_d {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 40%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton_c {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 60%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton_c:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.submitButton {
  line-height: 20px;
  padding: 4px 12px 5px 12px;
  font-size: 12px;
  color: #fff;
  background-color: unset;
  border-radius: 20px;
  border: 1px #fff solid;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%, 0);
}
.submitButton:hover {
  color: #414141;
  background-color: #fff;
  transition: 0.5s ease;
}
.prev_btn {
  left: calc(30% - 100px);
  bottom: 30px;
}
.next_btn {
  left: calc(70% + 100px);
  bottom: 30px;
}
.task_post .el-dialog {
  background-color: #585858;
}
.taskPage_task_edit {
  /*width: 100%;*/
  min-height: 500px;
  position: relative;
}

.taskPage_task_edit .taskContent_page {
  /*margin-left: 272px;*/
}
.commit_dialog {
  background-color: #585858;
}
.right_span {
  float: right;
}

@media screen and (max-width: 1024px) {
  .taskPage {
    width: 94%;
    /*min-width: 500px;*/
    padding: 3%;
  }
  .taskPage_task_edit {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskPage_task_b {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskContent_main {
    padding: 0 50px;
  }
}
@media screen and (max-width: 480px) {
	.task_result_content {
		margin-left: 4px!important;
	}
	.task_result_answer {
		margin-left: 4px!important;
	}
	.task_result_analysis {
		margin-left: 4px!important;
	}
	.task_result_analysis_answer {
		margin-left: 4px!important;
	}
}
.task_right {
	/* left: 16px;
	width: 5px;
	height: 5px;
	border-radius: 100%;
	background-color: #64cf80;
	position: absolute; */
	background: #64cf80!important;
}
.task_wrong {
	/* left: 16px;
	width: 5px;
	height: 5px;
	border-radius: 100%;
	background-color: #fc794f;
	position: absolute; */
	background: #fc794f!important;
}
.task_result_content {
	display: inline-flex;
	margin-left: 18px;
    margin-top: 15px;
}
.task_result_content span{
	padding-left: 5px;
}
.task_result_content .task_result_content_rigth{
	font-weight: bold;
	color: #129b0680;
}
.task_result_content .task_result_content_wrong{
	font-weight: bold;
	color: #f3040480;
}
.task_result_answer {
	display: inline-flex;
	margin-left: 18px;
    margin-top: 5px;
}
.task_result_answer .task_result_answer_a {
	color: rgba(10, 10, 10, 0.5);
	font-weight: bold;
	white-space: nowrap;
}
.task_result_answer .task_result_answer_b {
	color: #0071c5;
	font-weight: bold;
	margin-top: 2px;
}
.btn-tast span {
	padding-bottom: 5px;
	padding-top: 1px;
}
.task_result_analysis {
	display: inline-flex;
	margin-left: 18px;
    margin-top: 15px;
	font-weight: bold;
}
.task_result_analysis_answer {
	margin-left: 18px;
	font-weight: bold;
}
.task_result_analysis_a {
	white-space: nowrap;
	color: rgba(10, 10, 10, 0.5);
}
</style>
<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    margin-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/task_result_manage.vue